function ProfileService(ApiService) {
  'ngInject';

  const service = {};
    service.updateUser = function(profileForm, userId, callbackFunc){
      let data = {
        name: profileForm.name,
        email: profileForm.email,
        company_name: profileForm.company_name
      };
      ApiService.put(`/users/${userId}.json`, data, callbackFunc);
    };

  service.getProfile = function(callbackFunc){
    ApiService.get(`/users/me.json`, callbackFunc);
  };

  service.resetPassword = function(passwordForm,callbackFunc){
    ApiService.put(`/auth/password.json`, passwordForm, callbackFunc);
  };
  return service;
}

export default {
  name: 'ProfileService',
  fn: ProfileService
};
